<template>
  <div>
    <PageAllow controller="Distributions" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRangeWithRadio
              v-model="options"
              type="datetime"
              show-radios
              :radios="datetimeRadios"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">
                {{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}
              </v-icon>
            </v-btn>
            <v-col>
              <v-btn
                v-if="
                  $permission.permissionAllow(
                    'Distributions',
                    'batchDistribute'
                  )
                "
                small
                dark
                color="orange"
                class="ms-1 float-end"
                @click="batchDistributeDialog = true"
              >
                <v-icon x-small class="pe-1">fa-align-justify</v-icon>
                {{ $t("Distribution.actions.batchDistribute") }}
              </v-btn>
              <!-- 批量云打印 -->
              <v-menu
                v-if="
                  $permission.permissionAllow('Distributions', 'prints') &&
                  $permission.permissionAllow('CloudPrints', 'index') &&
                  settings &&
                  settings.cloud_print_enable
                "
                v-model="cloudPrintBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    dark
                    color="print"
                    class="ms-1 float-end"
                    @click.stop=""
                  >
                    <v-icon x-small class="pe-1">fa-print</v-icon>
                    {{ $t("Print.batch_cloud_print") }}
                    <v-icon x-small class="ps-1">
                      {{ cloudPrintBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    v-if="
                      $permission.permissionAllow('Distributions', 'prints')
                    "
                    @click.stop="doCloudPrint('distribution')"
                  >
                    <v-list-item-title>
                      {{ $t("Distribution.actions.batchPrintDistribution") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 配送单合并打印 -->
                  <!--                  <v-list-item-->
                  <!--                    v-if="-->
                  <!--                      $permission.permissionAllow(-->
                  <!--                        'Distributions',-->
                  <!--                        'shopDistributionsPrint'-->
                  <!--                      )-->
                  <!--                    "-->
                  <!--                    @click="doCloudPrint('shopMergeDistribution')"-->
                  <!--                  >-->
                  <!--                    <v-list-item-title>-->
                  <!--                      {{ $t("Distribution.actions.distrubitionsMergePrint") }}-->
                  <!--                    </v-list-item-title>-->
                  <!--                  </v-list-item>-->
                </v-list>
              </v-menu>
              <!-- 批量打印 -->
              <v-menu
                v-if="$permission.permissionAllow('Distributions', 'prints')"
                v-model="printBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    dark
                    color="print"
                    class="ms-1 float-end"
                    @click.stop=""
                  >
                    <v-icon x-small class="pe-1">fa-print</v-icon>
                    {{ $t("Print.batchPrint") }}
                    <v-icon x-small class="ps-1">
                      {{ printBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    v-if="
                      $permission.permissionAllow('Distributions', 'prints')
                    "
                    @click.stop="doPrint('distributionPrint')"
                  >
                    <v-list-item-title>
                      {{ $t("Distribution.actions.batchPrintDistribution") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 配送单合并打印 -->
                  <v-list-item
                    v-if="
                      $permission.permissionAllow(
                        'Distributions',
                        'shopDistributionsPrint'
                      )
                    "
                    @click="doPrint('distributionsMergePrint')"
                  >
                    <v-list-item-title>
                      {{ $t("Distribution.actions.distrubitionsMergePrint") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <!-- 批量导出 -->
              <!-- <v-btn
                v-if="
                  $permission.permissionAllow(
                    'Distributions',
                    'distributionForExpressExport'
                  )
                "
                small
                dark
                color="print"
                class="ms-1 float-end"
                @click="expressExport()"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("Distribution.actions.expressExport") }}
              </v-btn> -->
              <!-- 批量导入 -->
              <v-btn
                v-if="
                  $permission.permissionAllow('Distributions', 'expressImport')
                "
                small
                color="print"
                dark
                @click.stop="ImportDialog = true"
                class="ms-1 float-end"
              >
                <v-icon x-small class="pe-1">fa-file-import</v-icon>
                {{
                  $t("Import.import", [$t("Distribution.Fields.logistic_info")])
                }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="distribution_code"
                  v-model="options.distribution_code"
                  @text="distributionCodeKeyword = $event"
                  :label="$t('Distribution.distributionCodeKeyword')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStock
                  v-model="stocksSelected"
                  showVirtualStock
                  @change="distributionUserSelected = null"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherDistributionUser
                  v-model="distributionUserSelected"
                  mustStockId
                  :stockId="stocksSelected ? stocksSelected.id : 0"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherDistrictsWithDescendants v-model="districtSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="shop_keyword"
                  v-model="options.keyword"
                  @text="shopKeyword = $event"
                  :label="$t('Distribution.shopKeyword', [$consts.shopName()])"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="settings && settings.delivery_point && $permission.permissionAllow('DeliveryPoints', 'index')">
                <SearcherDeliveryPoint v-model="deliveryPointSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.status"
                  :label="$t('Distribution.status.title')"
                  :items="$consts.distribution.status"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.is_print"
                  :label="$t('Distribution.is_print.title')"
                  :items="$consts.distribution.is_print"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="distributions"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          mobile-breakpoint="800"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.distributions_code="{ item, index }">
            <span :v-resize="!index ? $stickTableResizer() : null"></span>
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.distributions_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.created | formatTime }}
            </span>
          </template>
          <template v-slot:item.shop.shop_name="{ item }">
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.shop ? item.shop.shop_name : "" }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.shop ? item.shop.shop_code : "" }}
            </span>
          </template>
          <template v-slot:item.distribution_user_name="{ item }">
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.distribution_user_name }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.stock ? item.stock.name : "" }}
            </span>
          </template>
          <template v-slot:item.order_code="{ item }">
            <a
              :href="'/#/orders/' + item.order_id"
              style="text-decoration: none"
            >
              {{ item.order_code }}
            </a>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | distributionStatusColor"
              :text-color="item.status | distributionStatusTextColor"
              >{{ item.status | distributionStatusText }}
            </v-chip>
          </template>
          <template v-slot:item.distribution_time="{ item }">
            {{ item.distribution_time | formatTime }}
          </template>
          <template v-slot:item.actions="{ item }">
            <DistributionActions
              :distribution="item"
              showView
              :showDistribute="item.actions.distribute"
              showLogistic
              showKdnLogistic
              @distribute="
                checkBeforeDistribute($event);
                currentItem = $event;
              "
              @editLogistic="getDistributionsFromAPI()"
            />
          </template>
        </v-data-table>
      </div>
    </v-sheet>

    <!-- 配送前校验运费是否已录入 -->
    <DialogAlert
      v-model="confirmToDistributeDialog"
      :title="$t('$vuetify.warning')"
      :message="$t('Distribution.Messages.confirmToDistribute')"
      persistent
      useConfirm
      @confirm="toDistribute(currentItem)"
    />
    <!-- 批量配送 -->
    <DialogAlert
      v-model="batchDistributeDialog"
      :title="$t('$vuetify.warning')"
      :message="$t('Distribution.Messages.batchDistributeAlert')"
      persistent
      useConfirm
      @confirm="
        batchDistributeDialog = false;
        batchDistributeInfoDialog = true;
        batchDistribute(JSON.parse(JSON.stringify(options)));
      "
    />
    <BatchOperationInfoAlert
      v-model="batchDistributeInfoDialog"
      :title="$t('$vuetify.alert')"
      :message="batchDistributeInfo"
      persistent
      :closable="errorCount > 0"
    />
    <ImportExcelAlert
      v-model="ImportDialog"
      :objName="$t('Distribution.Fields.logistic')"
      @import="
        excelFile = $event;
        importExcel();
      "
      downloadFromAPI
      @download="expressExport()"
    />
    <!-- 导入错误提示 -->
    <v-dialog persistent v-model="errorDistributionDialog" max-width="580px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="errorDistributionDialog = false"
              >
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8 text-center subtitle-1">
          {{ $t("Distribution.Messages.errorDistributionAlert") }}
          <span v-for="(item, key) in errorDistributionCodes" :key="key">
            <span>{{ item }}</span
            ><br />
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            outlined
            @click="errorDistributionDialog = false"
          >
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Distributions from "@/api/distributions";
import DistributionActions from "./plugins/Actions";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherDistributionUser from "@/components/plugins/SearcherDistributionUser";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";
import SearcherDeliveryPoint from "@/components/plugins/SearcherDeliveryPoint";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import DialogAlert from "@/components/plugins/DialogAlert";
import BatchOperationInfoAlert from "./plugins/BatchOperationInfoAlert";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";
import makeData from "./makeData";
import CloudPrintTemplates from "@/api/cloud_print_templates";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";

const defaultOptions = {
  created_time_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  expect_time_from: "",
  expect_time_to: "",
  distribution_code: "",
  keyword: "",
  stock_ids: [],
  distribution_user_id: null,
  district_codes: [],
  status: [1, 2],
  is_print: [0, 1],
  delivery_point_id: null,
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    DistributionActions,
    SearcherKeyword,
    SearcherStock,
    SearcherDistributionUser,
    SearcherDistrictsWithDescendants,
    SearcherStatus,
    DialogAlert,
    BatchOperationInfoAlert,
    ImportExcelAlert,
    SearcherDeliveryPoint,
    SearcherDatetimeRangeWithRadio,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.orderManagement"),
        disabled: false,
        replace: true,
        href: "/orders",
      },
      {
        text: i18n.t("Nav.distributions"),
        disabled: true,
        href: "/distributions",
      },
    ],
    headers() {
      return [
        {
          text:
            i18n.t("Distribution.Fields.distribution_code") +
            " / " +
            i18n.t("Distribution.Fields.created_time"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "distributions_code",
        },
        {
          text:
            i18n.t("Distribution.Fields.shop_name", [this.$consts.shopName()]) +
            " / " +
            i18n.t("Distribution.Fields.shop_code", [this.$consts.shopName()]),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "shop.shop_name",
        },
        {
          text: i18n.t("Distribution.Fields.order_code"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "order_code",
        },
        {
          text: i18n.t("Distribution.Fields.distribute_line"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "distribution_user_name",
        },
        {
          text: i18n.t("Distribution.Fields.distribute_status"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("Distribution.Fields.distribute_time"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "distribution_time",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "actions",
        },
      ];
    },
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("Distribution.Fields.created_time"),
      },
      {
        key: "expect",
        text: i18n.t("Distribution.Fields.expect_time"),
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols"]),
  },
  data: () => ({
    printBtnMenu: false,
    cloudPrintBtnMenu: false,
    distributionCodeKeyword: "",
    stocksSelected: null,
    distributionUserSelected: null,
    shopKeyword: "",
    districtSelected: [],
    deliveryPointSelected: null,
    options: JSON.parse(
      sessionStorage.getItem("distributions-options")
        ? sessionStorage.getItem("distributions-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    distributions: [],
    distributableOrders: [],
    batchDistributeDialog: false,
    errorCount: 0,
    successCount: 0,
    error_distribute_id: [],
    batchDistributeOrderLength: 0,
    alreadyDistributedOrderLength: 0,
    batchDistributeInfoDialog: false,
    batchDistributeInfo: i18n.t(
      "Distribution.Messages.batchDistributeInfo",
      [0, 0]
    ),
    confirmToDistributeDialog: false,
    currentItem: {},
    ImportDialog: false,
    errorDistributionCodes: [],
    errorDistributionDialog: false,
  }),

  mounted() {
    this.$commonUtils
      .loadOptions("distributions", [
        "stocksSelected",
        "distributionUserSelected",
        "districtSelected",
        "deliveryPointSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
              case "distributionUserSelected":
                this.distributionUserSelected = selected.value;
                break;
              case "districtSelected":
                this.districtSelected = selected.value;
                break;
              case "deliveryPointSelected":
                this.deliveryPointSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    resetSearch() {
      this.stocksSelected = null;
      this.distributionUserSelected = null;
      this.districtSelected = [];
      this.deliveryPointSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.distribution_code, this.$refs.shop_keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        distribution_code: this.distributionCodeKeyword,
        keyword: this.shopKeyword,
      });
    },
    getDistributionsFromAPI() {
      Distributions.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.distributions = response.data.distributions;
            this.paging = response.data.paging;

            let distributableOrders = [];
            this.distributions.forEach((distribution) => {
              //取可配送的单子
              if (distribution.actions.distribute) {
                distributableOrders.push(distribution);
              }
            });
            this.distributableOrders = distributableOrders;
            this.batchDistributeOrderLength = distributableOrders.length;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    toDistribute(distribution) {
      Distributions.distribute(distribution.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getDistributionsFromAPI();
            this.$store.commit("refreshToDos", true);
          }
        }.bind(this)
      );
    },
    checkBeforeDistribute(distribution) {
      Distributions.checkExpress(distribution.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.toDistribute(distribution);
          } else if (response.data.error.code == "ERR187") {
            this.confirmToDistributeDialog = true;
          }
        }.bind(this)
      );
    },
    doPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          var options = JSON.parse(JSON.stringify(this.options));
          options.page = 1;
          options.itemsPerPage = this.$consts.limitAll;
          switch (mode) {
            case "distributionPrint":
              this.$router.push({
                path: "/print/distributions-print",
                query: options,
              });
              break;
            // 配送单合并打印
            case "distributionsMergePrint":
              this.$router.push({
                path: "/print/distributions-merge-print",
                query: options,
              });
              break;
          }
        }.bind(this)
      );
    },
    doCloudPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          let options = JSON.parse(JSON.stringify(this.options));
          options.page = 1;
          options.itemsPerPage = this.$consts.limitAll;
          if (mode == "distribution") {
            Distributions.distributionsPrint(options).then(
              function (response) {
                if (response.data.status.isOK()) {
                  let distributions = response.data.distributions.map(
                    (distribution) => {
                      distribution.order.shop = this.$printUtils.addCitiesName(
                        distribution.order.shop
                      );
                      distribution.distribution_details.map((detail) => {
                        detail.print_date = new Date()
                          .toISOString()
                          .substr(0, 10);
                        return detail;
                      });
                      let result = {
                        order: distribution.order,
                        distribution: makeData.processDetails(distribution),
                        order_address: distribution.order_address,
                        print_date: new Date().toISOString().substr(0, 10),
                      };
                      if (distribution.stock_id) {
                        result.stock_id = distribution.stock_id;
                      }
                      return result;
                    }
                  );
                  CloudPrintTemplates.batchPrint({
                    print_template_code: mode,
                    objects: distributions,
                  });
                }
              }.bind(this)
            );
          } else if (mode == "shopMergeDistribution") {
            //获取单据详情
            Distributions.shopDistributionsPrint(options).then(
              function (response) {
                if (response.data.status.isOK()) {
                  let shopDistributions = [];
                  response.data.shop_distributions.forEach(
                    (shop_distribution) => {
                      shop_distribution.shop = this.$printUtils.addCitiesName(
                        shop_distribution.shop
                      );
                      shopDistributions.push(
                        Object.assign({}, shop_distribution, {
                          print_date: new Date().toISOString().substr(0, 10),
                        })
                      );
                    }
                  );
                  CloudPrintTemplates.batchPrint({
                    print_template_code: mode,
                    objects: shopDistributions,
                  });
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    batchDistribute(options) {
      if (this.error_distribute_id.length) {
        options.no_distribute_ids = this.error_distribute_id;
      }
      Distributions.batchDistribute(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.distribute_flg) {
              ++this.successCount;
            } else {
              this.error_distribute_id.push(response.data.distribution_id);
              ++this.errorCount;
            }
          } else {
            if (response.data.error.code != "ERR333") {
              this.error_distribute_id.push(response.data.distribution_id);
              ++this.errorCount;
            } else {
              this.getDistributionsFromAPI();
              options = null;
              this.error_distribute_id = [];
              this.successCount = 0;
              this.errorCount = 0;
              this.alreadyDistributedOrderLength = 0;
              this.batchDistributeInfoDialog = false;
              this.$store.commit("refreshToDos", true);
            }
          }
          //去除本次配送的单子
          this.distributableOrders.splice(0, 1);
          //实时计数
          this.batchDistributeInfo = i18n.t(
            "Distribution.Messages.batchDistributeInfo",
            [this.successCount, this.errorCount]
          );
          ++this.alreadyDistributedOrderLength; //计已审批的单子总数
          if (
            response.data.status.isOK() ||
            response.data.error.code != "ERR333"
          ) {
            //回调
            this.batchDistribute(options);
          }
        }.bind(this)
      );
    },
    expressExport() {
      Distributions.expressExport(this.options);
    },
    importExcel() {
      // console.log(this.excelFile);
      this.$store.dispatch("fullscreenLoading");
      Distributions.expressImport(this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              if (response.data.error_distribution_codes) {
                this.errorDistributionCodes =
                  response.data.error_distribution_codes;
                this.errorDistributionDialog = true;
              } else {
                this.$snackbar.info(
                  i18n.t("Import.success", [
                    i18n.t("Distribution.Fields.logistic_info"),
                  ])
                );
              }

              this.ImportDialog = false;
              this.getDistributionsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getDistributionsFromAPI();
        sessionStorage.setItem(
          "distributions-options",
          JSON.stringify(this.options)
        );
      },
    },
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected
          ? this.stocksSelected.id
          : "";
        sessionStorage.setItem(
          "distributions-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
    distributionUserSelected: {
      handler() {
        this.options.distribution_user_id = this.distributionUserSelected
          ? this.distributionUserSelected.id
          : "";
        sessionStorage.setItem(
          "distributions-distributionUserSelected",
          JSON.stringify(this.distributionUserSelected)
        );
      },
    },
    districtSelected: {
      handler() {
        this.options.district_codes = this.districtSelected
          ? this.districtSelected.map((e) => {
              return e.code;
            })
          : [];
        sessionStorage.setItem(
          "distributions-districtSelected",
          JSON.stringify(this.districtSelected)
        );
      },
    },
    deliveryPointSelected: {
      handler() {
        this.options.delivery_point_id = this.deliveryPointSelected
          ? this.deliveryPointSelected.id
          : null;
        sessionStorage.setItem(
          "distributions-deliveryPointSelected",
          JSON.stringify(this.deliveryPointSelected)
        );
      },
    },
  },
};
</script>